import { isCoreContractType } from "constants/moduleConstants/contract.constant";

const getPendingContractLabel = (contract, t) => {
  if (contract?.isSupplemental || !isCoreContractType(contract?.type)) {
    return (
      contract?.description ||
      t("contracts.list.customType", { defaultValue: "Custom Contract" })
    );
  }

  return (
    contract?.description ||
    t(`auth.signUp.form.contracts.types.${contract.type}`, {
      defaultValue: String(contract?.type ?? ""),
    })
  );
};

export default getPendingContractLabel;
